import React from 'react';
import { PhoneIncomingIcon, MoonStarIcon, TargetIcon } from 'lucide-react';
import { Card, CardHeader, CardBody } from '../Card';
import { Badge } from '../Badge';
type Benefit = {
  icon: React.ReactNode;
  title: string;
  body: string;
};
const BENEFITS: Benefit[] = [{
  icon: <PhoneIncomingIcon className="h-6 w-6" aria-hidden="true" data-id="element-130" data-mp="ywp2ymbibok7" />,
  title: '電話対応から解放される',
  body: '鳴り続ける電話に手を止められることがなくなります。受付の負担が減り、スタッフは目の前の仕事に専念できます。'
}, {
  icon: <MoonStarIcon className="h-6 w-6" aria-hidden="true" data-id="element-131" data-mp="1vm6cxdhivwrp" />,
  title: '営業時間外の取りこぼしゼロ',
  body: '夜間も定休日も、予約や問い合わせをしっかり受け止めます。「出られなかった一件」をなくし、機会損失を防ぎます。'
}, {
  icon: <TargetIcon className="h-6 w-6" aria-hidden="true" data-id="element-132" data-mp="1mkzw13ayojxx" />,
  title: '本業に集中できる',
  body: '雑務に追われる時間が減り、本来力を入れたい仕事やお客さまとの時間に集中できます。会社が前に進みはじめます。'
}];
export function BenefitsSection() {
  return <section id="benefits" className="w-full scroll-mt-24 bg-surface-muted" data-id="element-133" data-mp="b7xdi2paxkb4">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-24" data-id="element-134" data-mp="67ru19t6r444">
        <div className="mx-auto max-w-2xl text-center" data-id="element-135" data-mp="1gxysc9xvum4h">
          <Badge variant="sky" data-id="element-136" data-mp="1gygnf38t6uat">導入で変わること</Badge>
          <h2 className="mt-4 text-2xl font-bold text-text sm:text-3xl" data-id="element-137" data-mp="1kzaajuefg52n">
            「対応」から解放されて、本業に集中できる毎日へ
          </h2>
          <p className="mt-4 text-base leading-relaxed text-text-muted" data-id="element-138" data-mp="170kcabfvfzcp">
            AI受付スタッフがもたらすのは、むずかしい仕組みではなく、日々の働き方の変化です。
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-139" data-mp="1c0ouq70cb45k">
          {BENEFITS.map(b => <Card key={b.title} variant="elevated" className="h-full" data-id="element-140" data-mp="x7v4prnfz5mn">
              <CardHeader data-id="element-141" data-mp="1229382xehsvj">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-deep-navy text-white" data-id="element-142" data-mp="122sitczkw56e">
                  {b.icon}
                </span>
                <h3 className="mt-4 text-lg font-bold text-text" data-id="element-143" data-mp="t8w24dp6nkyd">{b.title}</h3>
              </CardHeader>
              <CardBody data-id="element-144" data-mp="ebn6h7sujv0u">{b.body}</CardBody>
            </Card>)}
        </div>
      </div>
    </section>;
}